import React from "react";

import { getIcon } from "../../../helpers/icons";
import { limitString } from "../../../helpers/format";
import Link from "../../../components/Link";
import Title from "../../../components/Title";
import Editor from "../../../components/Editor";
import Background from "../../../components/Background";

import style from "./style.module.css";

export default function Card(props) {

    const { 
        type, 
        item, 
        size="", 
        showDescription = 1, 
        showSocialMedia = 1 
    } = props;

    return (
        <div className={`${style.card} ${style[type]} ${style[size]}`}>
            <div className={style.cardInner}>
                <div className={style.cardRow}>
                    <div className={style.cardHeader}>
                        <div className={style.imageWrap}>
                            <Background 
                                src={item.image} 
                                size={type === "card" ? "640x480" : "640x480"} 
                                cPosition="bottomRight"
                            />
                        </div>
                    </div>
                    <div className={style.cardBody}>
                        <div className={style.name}>
                            <Title 
                                transform="uppercase" 
                                className="fontTeko" 
                                tag="h4"
                            >
                                {item.name}
                            </Title>
                        </div>
                        {
                            showDescription === 1 && (
                                <div className={style.desc}>
                                    <Editor text={limitString(item.desc, 20)} />
                                </div>
                            )
                        }
                    </div>
                    {
                        item.social_media !== null && showSocialMedia === 1 && (
                            <div className={style.cardFooter}>
                                {
                                    item.social_media.length > 0 && item.social_media.map((socialmediaMenu, socialmediaIndex) => {
                                        let icon = socialmediaMenu.icon ? getIcon(socialmediaMenu.icon) : '';
                                        if(socialmediaMenu.icon !== undefined && socialmediaMenu.url !== undefined) {
                                            return (
                                                <Link 
                                                    key={`socialmediaIndex_${socialmediaIndex}`} 
                                                    to={socialmediaMenu.url} 
                                                    className={style.socialmediaItem}
                                                >
                                                    {<i className={icon}></i>}
                                                </Link>
                                            )
                                        }
                                        else {
                                            return "";
                                        }
                                    })
                                }
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
}